import { RideBookingsPartialStoreState, RIDE_BOOKINGS_STATE_KEY } from './ride-bookings.reducer';

export const getBookings = (state: RideBookingsPartialStoreState) =>
    state[RIDE_BOOKINGS_STATE_KEY].bookings;

export const getLoading = (state: RideBookingsPartialStoreState) => state[RIDE_BOOKINGS_STATE_KEY].loading;

